export const GET_CURRENT_DISPLAY_NAME = "getCurrentDisplayName";
export const GET_USER_PROFILE = "getUserProfile";
export const CURRENT_USER_PROFILE = "currentUserProfile";
